<template>
  <div class="payment-header">
    <div class="container relative-section">
      <h2 class="relative-section section-title font-balo font-bold">
        <span>{{$t('app.étape 1')}}</span>
        <b>{{$t('app.Votre réservation')}}</b>
      </h2>
      <div class="text-center font-balo font-bold text-uppercase payment-step">
        <div class="list-inline">
          <div
            class="item-inline step step1"
            :class="{
                            active: step === 'step1' || step === 'step2' || step === 'step3'
                        }"
          >
            <div class="icon"></div>
            {{$t('app.sélectionnez')}}
            <br />
            {{$t('app.vos services & options')}}
          </div>
          <div
            class="item-inline step step2"
            :class="{ active: step === 'step2' || step === 'step3' }"
          >
            <div class="icon"></div>
            {{$t('app.choisissez')}}
            <br />
            {{$t('app.votre mode de paiement')}}
          </div>
          <div class="item-inline step step3" :class="{ active: step === 'step3' }">
            <div class="icon"></div>
            {{$t('app.votre réservation')}}
            <br />
            {{$t('app.est enregistrée')}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { get } from "lodash";
export default {
  name: "PaymentHeader",
  computed: {
    ...mapState({
      step: state => get(state, "cart.step", "step1")
    })
  }
};
</script>
